<template>
  <b-form-group
    label="KIB"
    label-for="kib"
    label-class="pb-0 pt-0"
  >
    <b-form-input
      v-model="kib"
      disabled
    />
  </b-form-group>
</template>
<script>
export default {
  props: {
    kib: { type: String, default: '' },
  },
}
</script>
